// src/axiosConfig.js
import axios from 'axios';

const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api/').replace(/\/$/, '');

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// ✅ Attach either authToken (preferred) or magicToken to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const authToken = localStorage.getItem('authToken');
    const magicToken = localStorage.getItem('magicToken');
    const token = authToken || magicToken;

    if (token) {
      config.headers['Authorization'] = `Token ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Auto-redirect to /expired on 403 (invalid token)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('magicToken');
      window.location.href = '/expired';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;